import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';
import { Constants } from './../../assets/constants';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  selectedProduct: any = {};
  memberInfo: any = {};
  constructor(private http: HttpClient, private errorService: ErrorService) {}

  cacheMemberInfo(memberInfo: any) {
    this.memberInfo = memberInfo;
  }
  cacheProductInfo(product: any) {
    this.selectedProduct = product;
  }
  memberInfoCache() {
    return this.memberInfo;
  }
  selectedProductCache() {
    return this.selectedProduct;
  }
  getMemberInfo(): Observable<any> {
    return this.http
      .get(environment.apiUrlbase + environment.endPoints.memberInfo)
      .pipe(
        map((responseData) => {
          let response: any = {};
          response = responseData;
          return response;
        }),
        catchError((errorRes) => {
          this.errorService.openErrorPopup(
            errorRes.error && typeof errorRes.error === 'string'
              ? errorRes.error
              : Constants.genericErrorMessage
          );
          return throwError(errorRes);
        })
      );
  }

  getMemberProducts(): Observable<any> {
    return this.http
      .get(environment.apiUrlbase + environment.endPoints.memberInfo)
      .pipe(
        map((responseData) => {
          let response: any = {};
          response = responseData;
          return response;
        }),
        catchError((errorRes) => {
          this.errorService.openErrorPopup(
            errorRes.error && typeof errorRes.error === 'string'
              ? errorRes.error
              : Constants.genericErrorMessage
          );
          return throwError(errorRes);
        })
      );
  }
}
